export default __webpack_public_path__ + "assets/capturBagMid.329381d8.png";